import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import SkeletonBlock from 'dpl/common/design_system/SkeletonBlock';
import { isLessThanBreakpoint } from 'dpl/util/grid';

const IS_LT_MD = isLessThanBreakpoint('md');

/** @param {any} props */
export default function ResultsHeadingSkeleton({ className = null }) {
  return (
    <div className={classnames('ResultsHeadingSkeleton', className)}>
      <SkeletonBlock
        className="font-14 md:font-16"
        height="1em"
        width={IS_LT_MD ? '100%' : '35em'}
      />
      {IS_LT_MD && (
        <SkeletonBlock
          className="font-14 md:font-16 mt1"
          height="1em"
          width="30%"
        />
      )}
    </div>
  );
}

ResultsHeadingSkeleton.propTypes = {
  className: PropTypes.string
};
